var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:{ active: _vm.active },attrs:{"id":_vm.id,"type":_vm.type,"tabindex":_vm.tabindex,"aria-selected":_vm.ariaSelected,"aria-controls":_vm.controls,"role":"tab"},on:{"focus":_vm.handleFocusEvent,"click":_vm.handleClickEvent,"keydown":_vm.handleKeydownEvent}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-067d513b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/tabs/TabsContainerTablistTab.vue
// module id = null
// module chunks = 